const defaultValue: Record<string, string> = {};

function parseUrlParameters(url: string) {
    if (!url || typeof url !== 'string') {
        return defaultValue;
    }

    let parsedUrl: URL;

    try {
        parsedUrl = new URL(url);
    } catch (err) {
        return defaultValue;
    }

    const { searchParams } = parsedUrl;

    const paramKeys = [...searchParams.keys()];

    if (paramKeys.length <= 0) {
        return defaultValue;
    }

    return paramKeys.reduce(
        (output: Record<string, string>, paramKey: string) => {
            const value = searchParams.get(paramKey) || '';
            output[paramKey] = value;
            return output;
        },
        {},
    );
}

export { parseUrlParameters };
